<p>
  setup-peach-payments works!
</p>
